// extracted by mini-css-extract-plugin
export var emailBlockLink = "_i7-0";